import React from "react";

import Skeleton from ".";

const TABLE_PROPS = {
	header: { height: 55 },
	body: { marginTop: 5 },
	footer: { height: 55, marginTop: 5 },
};

const defaultProps = {
	header: {},
	body: {},
	footer: {},
};
type Props = typeof defaultProps;

export const TableLoader = ({ header, body, footer }: Props) => (
	<>
		<Skeleton height={`${TABLE_PROPS.header.height}px`} {...header} />
		<Skeleton
			flex="1"
			height="unset"
			marginTop={`${TABLE_PROPS.body.marginTop}px`}
			{...body}
		/>
		<Skeleton
			height={`${TABLE_PROPS.footer.height}px`}
			marginTop={`${TABLE_PROPS.footer.marginTop}px`}
			{...footer}
		/>
	</>
);
